import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";

import "pdfjs-dist/webpack";

import Viewer from "@phuocng/react-pdf-viewer";

export { Viewer as default };
